import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { Newsletter } from '@@api/services/newsletter/schemas';
import { deserializeNewsletter } from '@@api/services/newsletter/transformers';
import { SearchParams } from '@@api/utils/schemas/queryParams';
import config from '@@config';

export const newsletterService = defineService(
    (defineEndpoint) => ({
        newsletter: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/newsletters',
                query: z.object({
                    ...SearchParams.pick({ q: true }).shape,
                    active: z.boolean().nullish(),
                }),
                responses: {
                    200: z.array(Newsletter.transform(deserializeNewsletter)),
                },
            }),
            get: defineEndpoint({
                method: 'GET',
                path: '/newsletters/:id',
                pathParams: z.object({
                    id: z.string().uuid(),
                }),
                responses: {
                    200: Newsletter.transform(deserializeNewsletter),
                },
            }),
            put: defineEndpoint({
                method: 'PUT',
                path: '/newsletters/:id',
                pathParams: z.object({
                    id: Newsletter.shape.id,
                }),
                body: Newsletter,
                responses: {
                    200: Newsletter.transform(deserializeNewsletter),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.newsletterUrl,
    },
);
